module.exports = __webpack_public_path__ + "img/sku-detail-bg.386fe1e.jpg";